import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=68fc3a6b&scoped=true&"
import script from "./SimpleCard.vue?vue&type=script&lang=js&"
export * from "./SimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=68fc3a6b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc3a6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VHover,VImg})
